import { useState, useCallback, createContext } from 'react';
import { constant, noop } from 'lodash-es';

export function useExpanded() {
  const [expandedRows, setExpandedRows] = useState<string[]>([]);
  const isExpanded = useCallback(
    (id: string) => expandedRows.includes(id),
    [expandedRows]
  );
  const toggleExpand = useCallback(
    (id: string) => {
      const expandedRowsClone = Array.from(expandedRows);
      const idx = expandedRowsClone.indexOf(id);
      if (idx >= 0) {
        expandedRowsClone.splice(idx, 1);
        setExpandedRows(expandedRowsClone);
      } else {
        setExpandedRows([...expandedRowsClone, id]);
      }
    },
    [expandedRows]
  );
  return [isExpanded, toggleExpand] as const;
}

export const ExpandContext = createContext<{
  isExpanded: (id: string) => boolean;
  toggleExpand: (id: string) => void;
}>({ isExpanded: constant(false), toggleExpand: noop });
